import { render } from "./MABarChart.vue?vue&type=template&id=df447568&scoped=true"
import script from "./MABarChart.vue?vue&type=script&lang=ts"
export * from "./MABarChart.vue?vue&type=script&lang=ts"

import "./MABarChart.vue?vue&type=style&index=0&id=df447568&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-df447568"

export default script